import Big from 'big.js';

export class TransactionReportRecord {

  readonly amount: Big;

  readonly lbsPurchased: number;

  readonly piecesPurchased: number;

  readonly reportsNumber: number;

  readonly year: number;

  readonly month: string;

  /**
   * Converts JSON representation of name into {@link TransactionReportRecord} instance.
   *
   * @param jsonObject JSON representation of transaction report record
   */
  static fromJSON(jsonObject: any): TransactionReportRecord {
    const result = Object.create(TransactionReportRecord.prototype);
    return Object.assign(result, jsonObject);
  }

}
